<template>
  <div class="px-2">

    <h2>{{ title }}</h2>
    <div class="flex flex-wrap -mx-2">
      <div @click.prevent="select(pm)" v-for="pm in paymentMethods" class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4" >
        <div class="card simple-card" :class="[selected.uid === pm.uid ? 'selected' : '']" >
          <div v-if="selected.uid === pm.uid" class="chosen">
            <span class="md:hidden sm:hidden" >Ausgewählt</span>
            <icon name="check"></icon>
          </div>
          <div class="card-media-wrapper">
            <img :src="'/static/icon-' + pm.card_brand.replace(/ /g, '_') + '.png'" alt="">
            <div class="address">
              <h6>{{ pm.card_brand }}</h6>
              <span>endet auf {{ pm.card_last4 }}</span>
              <span>Ablaufdatum: {{ pm.card_exp_month }}/{{ pm.card_exp_year }}</span>
              <span v-if="pm.cardholder_name">Name auf der Karte: {{ pm.cardholder_name }}</span>
            </div>
          </div>
          <div class="actions">
            <span v-if="pm.default" class="text-cg-success">Standard</span>
            <a v-if="!pm.default" @click.prevent="setStandard(pm)" href="#" class="standard">Als Standard festlegen</a>
            <a v-if="selected.uid !== pm.uid" @click.prevent="removePayMethod(pm)" class="delete">Löschen</a>
          </div>
        </div>
      </div>
      <div class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4">
        <div class="card simple-card new-card">
          <button @click.prevent="showModal()" class="btn icon green"><span><icon class="icon" name="plus-circle"></icon></span><span>Neue Zahlungsart hinzufügen</span>
          </button>
        </div>
      </div>
    </div>
    <payment-modal v-on:saved="select" v-on:close="closeModal" ></payment-modal>
  </div>
</template>

<script>
  import PaymentModal from '../modals/Payment'
  import {mapGetters, mapActions} from 'vuex'
  import {EventBus} from '@/assets/js/event-bus.js'

  export default {
    components: {PaymentModal},
    name: 'paymentMethods',
    props: {
      selected: {
        type: Object,
        default: function () {
          return {}
        }
      },
      title: {
        type: String,
        default: 'Meine Zahlungsarten'
      }
    },
    data () {
      return {
        userInfo: {},
        showPaymentModal: false,
        saveToast: null
      }
    },
    mounted () {
      var self = this
      this.getPaymentDetails({
        cb () {
          if (!self.selected.uid) {
            for (var p in self.paymentMethods) {
              if (self.paymentMethods[p].default) {
                self.preselect(self.paymentMethods[p])
              }
            }
          }
        }
      })
    },
    methods: {
      ...mapActions([
        'getPaymentDetails',
        'deletePaymentDetail',
        'standardPaymentDetail'
      ]),
      preselect (pm) {
        this.$emit('preselected', pm)
      },
      select (pm) {
        this.$emit('selected', pm)
      },
      closeModal () {
        this.showPaymentModal = false
        EventBus.$emit('togglePaymentModal')
      },
      showModal () {
        this.showPaymentModal = true
        EventBus.$emit('togglePaymentModal')
      },
      setStandard (pm) {
        var vm = this
        if (!vm.saveToast) {
          vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            icon: 'info'
          })
          this.standardPaymentDetail({
            user: vm.account.uid,
            paymentDetail: pm.uid,
            cb: () => {
              vm.saveToast.goAway(100)
              vm.saveToast = null
              vm.$toasted.success('Die ausgewählte Zahlungsart ist jetzt Standard.', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                action: {
                  text: 'X',
                  class: 'toastBtn',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
                icon: 'check'
              })
            },
            errorCb: () => {
              vm.saveToast.goAway(100)
              vm.saveToast = null
              vm.$toasted.error('Leider ist ein Fehler aufgetreten. Bitte versuche es später', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                action: {
                  text: 'X',
                  class: 'toastBtn',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
                icon: 'close'
              })
            }
          })
        }
      },
      removePayMethod (pm) {
        var vm = this
        pm.cb = () => {
          vm.$toasted.success('Die ausgewählte Zahlungsart wurde gelöscht.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'check'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        pm.errorCb = () => {
          vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        vm.$dialog.confirm('Möchtest Du diese Zahlungsart löschen?').then(() => {
          if (!vm.saveToast) {
            vm.saveToast = vm.$toasted.info('Wird gelöscht...', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              icon: 'info'
            })
            vm.deletePaymentDetail(pm)
          }
        }).catch(() => {})
      }
    },
    computed: {
      ...mapGetters({
        'paymentMethods': 'user_get_payment_details',
        'account': 'auth_get_account'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/paymentMethods.vue